var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-row',{staticClass:"pt-2",attrs:{"vs-type":"flex","vs-align":"center"}},[(_vm.iconName)?_c('vs-icon',{attrs:{"icon":_vm.iconName,"size":"medium","color":_vm.iconColor}}):_vm._e(),_c('span',{staticClass:"pl-4"},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }